module.exports = __webpack_public_path__ + "assets/images/logo-image-only.b49d30baf4221e2a4efcc6e85ce66c78.png";